import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '../../components/Card/Card';
import CustomButton from '../../components/customButton/CustomButton';
import FormInput from './components/FormInput/FormInput';
import CheckboxWithLink from './components/CheckboxWithLink/CheckboxWithLink';
import TermsOfUseModal from './components/TermsOfUseModal/TermsOfUseModal';
import './ConfirmationForm.css';
import { termsOfUseRepository } from '../../repositories/termsOfUseRepository';
import { ipService } from '../../services/ipService';

const ConfirmationForm = ({ userData }) => {
  const history = useHistory();
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [termsOfUse, setTermsOfUse] = useState('');

  React.useEffect(() => {
    const fetchTerms = async () => {
      await getTermsOfUse();
    };

    fetchTerms();

    if (userData) {
      if (userData.cpfCnpj) setCpfCnpj(userData.cpfCnpj);
      if (userData.email) setEmail(userData.email);
      if (userData.phone) setPhone(userData.phone);
      if (userData.isAcceptedTerms) setTermsAccepted(userData.isAcceptedTerms);
    }
  }, [userData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userIp = await ipService.getIpAddress();

      const termsResponse = {
        termId: termsOfUse.id,
        isAcceptedTerms: termsAccepted,
        ip: userIp,
        email,
        cpfCnpj,
        phone,
      };

      await termsOfUseRepository.replyTermsOfUse(termsResponse);
      localStorage.setItem('USER_CONFIRMED', 'true');
      history.push("/client/dashboard");
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  const getTermsOfUse = async () => {
    const response = await termsOfUseRepository.getTermsOfUse();
    setTermsOfUse(response.data);
  };

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setIsModalOpen(false);
  };

  return (
    <div className="confirmation-form-container">
      <Card
        title="Dados Pessoais"
        category="Confirme os dados para confirmar sua conta:"
        content={
          <form onSubmit={handleSubmit}>
            <FormInput
              label="CPF/CNPJ"
              id="cpfCnpj"
              type="text"
              value={cpfCnpj}
              onChange={(e) => setCpfCnpj(e.target.value)}
              placeholder="CPF/CNPJ"
              disabled={!!userData?.cpfCnpj}
            />
            <FormInput
              label="E-mail"
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail"
              disabled={!!userData?.email}
            />
            <FormInput
              label="Telefone Celular"
              id="phone"
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="( )     -"
              disabled={!!userData?.phone}
            />
            <CheckboxWithLink
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              labelText="Declaro que li e aceito os"
              linkText="termos de uso"
              onClickLink={() =>  setIsModalOpen(true)}
            />
            <div className="form-group button-container">
              <CustomButton fill type="submit" bsStyle="success"
                disabled={!cpfCnpj || !email || !phone || !termsAccepted}
              >
                Salvar
              </CustomButton>
            </div>
            <div className="help-text">
              Em caso de dúvidas ou problemas, contate o{' '}
              <a href="mailto:ouvidoria@sobrerodas.club">ouvidoria@sobrerodas.club</a>
            </div>
          </form>
        }
      />
      <TermsOfUseModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAccept={handleAcceptTerms}
        children={termsOfUse.description}
        initialChecked={termsAccepted}
      />
    </div>
  );
};

export default ConfirmationForm;